export const projects = [
  {
    img: "https://res.cloudinary.com/ddnulyays/image/upload/v1771225873/Screenshot_2026-02-16_124051_t5hqku.png",
    title: "Loopera",
    des: "We Develop So You Level Up!",
    demo: "",
    live: "https://looperatechnologies.netlify.app/",
    gitHub: "",
    technologies: [
      "HTML",
      "CSS",
      "JavaScript",
       "React Js",
      "Node Js"
    ],
  },
  {
    img: "https://res.cloudinary.com/ddnulyays/image/upload/v1771225223/Screenshot_2026-02-16_122956_gfftwi.png",
    title: "Heti's Kitchen",
    des: "Heti's Kitchen",
    demo: "",
    live: "https://hetiskitchen.com/",
    gitHub: "",
    technologies: [
      "HTML",
      "CSS",
      "JavaScript",
      "React Js",
      "Node Js"
    ],
  },
  

  
 
  ];
